import emailCompatibility from './emailCompatibility';
import recipientsShipping from './recipientsShipping';
import submit from './submit';

const sagas: any = {
  ...emailCompatibility,
  ...recipientsShipping,
  ...submit,
};

export default sagas;
